var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h-dialog',{attrs:{"title":_vm.title},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('h-link',_vm._g(_vm._b({staticClass:"activator"},'h-link',attrs,false),on),[_vm._v(_vm._s(_vm.$t('components.account_voucher.contribution_hints.link_title')))])]}}])},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.htmlContent)}})])}
var staticRenderFns = []

export { render, staticRenderFns }